import React from 'react';

const Education = () => (
    <div className="service-page">
        <h1>Education</h1>
        <p>Find top educational institutions, schools, colleges, and training centers.</p>
    </div>
);

export default Education;
